"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueForClipboard = void 0;
const constants_1 = require("../../constants");
require("../../core");
const isObject_1 = require("./isObject");
const getValueForClipboard = (value, key = 'name', separator = '\n', emptyValue = constants_1.EMPTY_TEXT.dash) => {
    var _a;
    if (isObject_1.isObject(value)) {
        return (_a = value === null || value === void 0 ? void 0 : value[key]) !== null && _a !== void 0 ? _a : emptyValue;
    }
    if (Array.isArray(value)) {
        return value.map((item) => item[key] || emptyValue).join(separator) || emptyValue;
    }
    if (typeof value === 'string') {
        return value || emptyValue;
    }
    return emptyValue;
};
exports.getValueForClipboard = getValueForClipboard;
//# sourceMappingURL=getValueForClipboard.js.map